import { WalletHistoryListWrapper } from "./style";
import WalletHistorySkeletonItem from "./components/history-item/skeleton";

const WalletHistorySkeleton = () => {
  return (
    <WalletHistoryListWrapper>
      {Array.from({ length: 10 }, (_, index) => (
        <WalletHistorySkeletonItem key={index} />
      ))}
    </WalletHistoryListWrapper>
  );
};

export default WalletHistorySkeleton;
